import { randomString } from './random'
import hexToRgba from './hexToRgba'
import { runTimer } from './timer'
import throttle from './throttle'
import debounce from './debounce'
import copyToClip from './copyToClip'
import { inModule, idleInModule, idleInModuleList, } from './inModule'
import { jsonStrToValue } from './json'
import getUrlQuery from './getUrlQuery'
import fixTime from './fixTime'
import downloadExcel from './downloadExcel'
import setTimeRange from './setTimeRange'
import handleTimestamp from './handleTimestamp'
import downloadImage from './downloadImage'
import replaceParamVal from './replaceParamVal'
import borwserLang from './borwserLang.js'

import {
  checkType,
  isArray,
  isString,
  isNumber,
  isObject,
  isBoolean,
  isFunc,
  isRe,
  isJsonString,
  isEmpty,
  hasEmpty,
  isNaN,
  isZero,
} from './verifyType'

const fieldSet = (obj, key, value = null) => {
  if (isEmpty(obj[key])) {
    return
  }
  obj[key] = value
}

const toRouter = (path) => {
  router.push(path)
}

const scrollbottom = (dom) => {
  const scrollTop = dom.scrollTop
  const clientHeight = dom.clientHeight
  const scrollHeight = dom.scrollHeight
  if (scrollTop + clientHeight >= scrollHeight - 10) {
    return true
  } else {
    return false
  }
}

const delNullKey = data => {
  if (data.isFilterNull === false) {
    delete data.isFilterNull
    return data
  }
  return Object.keys(data).reduce((o, k) => {
    const e = {}
    const item = data[k]
    if (!isEmpty(item)) {
      e[k] = item
    }
    if (isObject(item)) {
      e[k] = delNullKey(item)
    }
    return { ...o, ...e }
  }, {})
}

const tryCatch = async (cb) => {
  try {
    return [null, await cb()]
  } catch (err) {
    return [err, null]
  }
}

export {
  checkType,
  isArray,
  isString,
  isNumber,
  isObject,
  isBoolean,
  isFunc,
  isRe,
  isJsonString,
  isEmpty,
  isNaN,
  isZero,
  hasEmpty,
  randomString,
  hexToRgba,
  runTimer,
  throttle,
  debounce,
  copyToClip,
  fieldSet,
  downloadImage,
  inModule,
  idleInModule,
  idleInModuleList,
  toRouter,
  scrollbottom,
  jsonStrToValue,
  delNullKey,
  fixTime,
  downloadExcel,
  getUrlQuery,
  setTimeRange,
  tryCatch,
  handleTimestamp,
  replaceParamVal,
  borwserLang
}
